module.exports = __webpack_public_path__ + "static/media/poster.e6c9ab54.png";